/**
 * Deal Jacket Notes
 *
 * This is the component that displays the
 * listing of notes.
 *
 * Used in ViewAllPages2 and *I think* Search Result Row
 *
 */

import React, { useEffect} from "react";
import { connect } from "react-redux";
import { notesActions } from "../../actions";
import {DateTimeDisplay} from "../common/DateTimeDisplay";

function DealJacketNotes(props) {
  const { org_id, notes, getNotes, deal_jacket_id } = props;


    useEffect(() => {
      getNotes(org_id, deal_jacket_id);
    }, [org_id, deal_jacket_id, getNotes]);

    return (
      <div className="notesContainer rightColumn">
      {!notes && (
        <div className="dealJacketNotes">
          Loading Notes...
        </div>
      )}
      {notes && notes.length < 1 && (
        <div className="dealJacketNotes">
          No notes
        </div>
      )}
        {notes && (
          <ul className="dealJacketNotes">
            {React.Children.toArray(
              notes.map((note, i) => (
                <li className="singleJacketNote">
                  <p>{note.content}</p>
                  <p>–{note.create_user}</p>
                  <DateTimeDisplay date={ new Date(note.create_date) } />
                  <hr className="dealJacketNotes_hr"/>
                </li>
            )))}
          </ul>
        )}
      </div>
    );
};

function mapStateToProps(state) {
    const { notes } = state;
    return {
      notes: notes.list
    };
  }

 const actionCreators = {
  getNotes: notesActions.getNotes,
};

const connectedDealJacketNotes = connect(
  mapStateToProps,
  actionCreators
)(DealJacketNotes);

export { connectedDealJacketNotes as DealJacketNotes };
